<template>
  <div class="cwSplitBoxWrapper" v-show="isVisible">
    <h3 class="cwSplitBoxWrapper-label" v-if="cmpConfig.component.decorator">
      <span>{{ getCactusString(cmpConfig.component.decorator.label_module[0]) }}</span>
    </h3>
    <div class="dropdownGroup">
      <div class="dropdownGroup-item" v-for="(cmp, index) in fwParams" :key="index">
        <cwSplitBoxItem
          :cmpConfig="cmp"
          :fwParams="getParams(cmp.instance_param_name)"
        ></cwSplitBoxItem>
      </div>
    </div>
  </div>
</template>

<script>
import cwSplitBoxItem from './cwSplitBoxItem';
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwSplitBoxWrapper',
  mixins: [expertviewMixin],
  components: { cwSplitBoxItem },
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      cactusElements: require('./cactus_elements.json')
    };
  },
  created() {
    this.$log.debug('cwSplitBoxWrapper::created()', this.cmpConfig);

    this.applyRules();
  },
  methods: {
    getParams(paramName) {
      return this.cactusElements.firmware_params[paramName] || [];
    }
  }
};
</script>

<style scoped lang="scss">
.cwSplitBoxWrapper {
  padding-bottom: 24px;
  width: 96px;
  margin: 0 auto;

  &-label {
    @include textSmall;
    color: $bluey-grey;
    margin: 2px 0 4px 4px;
  }

  .dropdownGroup {
    background-color: $cloudy-blue-20;
    border: 1px solid $cloudy-blue;
    border-radius: 8px;
    height: 80px;

    &-item {
      display: block;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid $cloudy-blue;
      font-size: 14px;
      color: $petrol;
      text-align: center;

      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>
